import React from "react";
import styled from "styled-components";
import { withPrefix, Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import AutosuggestSearch from "../controls/AutosuggestSearch";
import dataPages from "../../data/pages.json";
import { ArrowRight, ArrowUpRight } from "../Arrow";
import Button from "../Button";



const DiscussionLanding = ({entities, getEntityHash, getEntityTitle, entityHasFlag}) => {
  const dataPage = dataPages.find((page) => page.slug === "discussion");

  const countEntitiesReplied = entities.filter((entity) => entity.count_replies > 0).length;
  let countEntityInquiries = 0;
  entities.forEach((entity) => {
    countEntityInquiries += entity.count_inquiries;
  });
  const itemsUniqueCountries = [...new Set(entities.map((item) => item.country.name))].sort();
  const countUyghurLabor = entities.filter((entity) => entityHasFlag(entity, "uyghur-labor")).length;
  const countNorthKoreanLabor = entities.filter((entity) => entityHasFlag(entity, "north-korean-labor")).length;
  const countEnvironmentalConcern = entities.filter((entity) => entityHasFlag(entity, "environmental")).length;
  const countHumanRightsConcern = entities.filter((entity) => entityHasFlag(entity, "human-rights")).length;

  const examples = [
    {
      name: "High Liner",
      slug: "high-liner-foods-inc"
    },
    {
      name: "Sysco",
      slug: "sysco-us"
    },
    {
      name: "Marine Stewardship Council",
      slug: "marine-stewardship-council"
    },
    {
      name: "Trident Seafoods",
      slug: "trident-seafoods-corporation-pickenpack"
    }
  ];
  return (
    <StyledDiscussionLanding>
      <StyledDiscussionLandingHeader>
        <span>
          <StaticImage src="../../images/bg-discussion.jpg" alt="" />
        </span>
        <div className="search">
          <div>
            <h1 className="title">{dataPage.label}</h1>
            <p className="description">{dataPage.description}</p>
          </div>
          <div>
            <AutosuggestSearch 
              searchIndex={entities} 
              getEntityHash={getEntityHash}
              getEntityTitle={getEntityTitle}
              placeholderText="Search stakeholders..."
            />
            <p className="examples">Examples:&nbsp;
              {examples.map((example, index) => {
                return (
                  <React.Fragment key={example.slug}>
                    {index > 0 && ", "}
                    <Link to={`/discussion/stakeholders/${example.slug}`}>{example.name}</Link>
                  </React.Fragment>
                );
              })}
            </p>
          </div>
          <a className="methodology" href={withPrefix(`/methodology/#method-discussion`)} target="_blank" relf="noopener noreferrer" title="Methodology">
            <span>Methodology</span> <ArrowUpRight />
          </a>
        </div>
      </StyledDiscussionLandingHeader>
      
      <StyledDiscussionLandingStats>
        <p><Link className="reach" to="/discussion/stakeholders" title="View all stakeholders">{countEntityInquiries} inquiries sent to {entities.length} stakeholders in {itemsUniqueCountries.length} countries.</Link> <Link className="uyghur" to="/discussion/stakeholders/?flags=uyghur-labor">{countUyghurLabor} linked to Uyghur Labor.</Link> <Link className="nk" to="/discussion/stakeholders/?flags=north-korean-labor">{countNorthKoreanLabor} linked to North Korean Labor.</Link> <Link className="hr" to="/discussion/stakeholders/?flags=human-rights">{countHumanRightsConcern} linked to Human Rights & Labor Concerns.</Link> <Link className="env" to="/discussion/stakeholders/?flags=environmental">{countEnvironmentalConcern} linked to Fishing & Environmental Concerns.</Link> </p>
        <Button as={Link} to="/discussion/stakeholders" title="View all stakeholders" className="is-inversed">Browse all Discussions <span className="arrow"><ArrowRight /></span></Button>
      </StyledDiscussionLandingStats>
    </StyledDiscussionLanding>
  );
};

export default DiscussionLanding;

const StyledDiscussionLandingHeader = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1.5em;
  padding-top: calc(var(--navbar-height) + 1.5em);
  padding-bottom: 4em;
  > span {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    width: 100vw;
    margin-left: -50vw;
    display: block;
    z-index: -1;
    opacity: 0.8;
    .gatsby-image-wrapper {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      height: 100%;
      object-fit: contain;
      img {
        object-position: right center !important;
      }
    }
    @media ( max-width: 48em ) {
      opacity: 0.6;
      .gatsby-image-wrapper {
        left: 0;
        right: auto;
        img {
          object-position: center center !important;
        }
      }
    }
  }
  > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1.5em;
  }
  .title {
    font-family: var(--font-serif);
    font-size: 2.5em;
    line-height: 1;
    margin: 0;
    @media ( min-width: 60em ) {
      font-size: 3.5em;
    }
  }
  .description {
    font-weight: 500;
    max-width: 30em;
    @media ( min-width: 60em ) {
      font-size: 1.125em;
    }
  }

  .examples {
    font-size: 0.8125em;
    a {
      text-decoration: underline;
      text-decoration-thickness: 0.75px;
      text-underline-offset: 0.1em;
      text-decoration-color: rgba(255,255,255,0.5);
      .can-hover &:hover {
        text-decoration-color: var(--color-white);
      }
    }
  }

  .methodology {
    position: relative;
    display: inline-flex;
    align-items: center;
    align-self: start;
    padding: 0 1em 0 1.125em;
    height: 2.25em;
    border-radius: 7.5em;
    font-size: 0.75em;
    font-weight: 700;
    letter-spacing: 0.025em;
    border: 1px solid;
    opacity: 1;
    transition: background-color 0.2s ease, color 0.2s ease;
    span {
      margin-right: 0.5em;
    }
  }
  .can-hover & .methodology:hover,
  .methodology:active {
    background-color: var(--color-white);
    color: var(--color-black);
  }

  @media ( max-width: 48em ) {
    padding-top: calc(var(--navbar-height) + 5em);
  }
  @media ( min-width: 60em ) {
    padding: calc(var(--navbar-height) + 3em) 10% 2em;
  }
  
`;

const StyledDiscussionLandingStats = styled.div`
  position: relative;
  padding-top: 2em;
  padding-bottom: 3em;
  align-items: start;

  background-color: var(--color-white);
  color: var(--color-black);
  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100vw;
    left: 50%;
    margin-left: -50vw;
    background-color: inherit;
    z-index: -1;
  }

  @media ( min-width: 48em ) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 1em;
  }
  @media ( min-width: 60em ) {
    padding: 3em 10% 4em;
  }
  p {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5em;
    max-width: 48em;
    span,
    a {
      display: inline-block;
      padding: 0.125em 0.25em;
      font-weight: 700;
      color: var(--color-black);
      &.reach {
        background-color: var(--color-black);
        color: var(--color-white);
      }
      &.uyghur {
        background-color: var(--color-uyg);
      }
      &.nk {
        background-color: var(--color-nk);
      }
      &.hr {
        background-color: var(--color-hr);
      }
      &.env {
        background-color: var(--color-env);
      }
    }
    @media ( max-width: 48em ) {
      width: 100%;
      font-size: 0.875em;
      margin-bottom: 2em;
    }
  }
`;


const StyledDiscussionLanding = styled.div`
  position: relative;
  display: grid;
  margin-top: calc(-1 * var(--navbar-height));
  min-height: 100vh;
  @media ( min-width: 60em ) {
    grid-template: 1fr auto / 1fr;
    min-height: 100vh;
  }
`;